export default __webpack_public_path__ + "guide-access-elevation-data-example-response-480-13f6104b3ca46c0c5b6c97d143ecfb17.png";